import { useRef } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccountRouterProps } from "../AccountRouterProps";
import { NSBoxSensitive } from 'namirasoft-site-react';
import { NSButtonBlue } from 'namirasoft-site-react';
import { AccountLayout } from "../AccountLayout";
import { NSSection, NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { NSPanel } from 'namirasoft-site-react';
import { AccountRoutes } from "../AccountRoutes";

interface PasswordChangePageProps extends NSARouterMakerResult, AccountRouterProps
{ }

function PasswordChangePage(props: PasswordChangePageProps) 
{
    const NSBoxSensitive_Cur_Password = useRef<NSBoxSensitive>(null);
    const NSBoxSensitive_NewPassword = useRef<NSBoxSensitive>(null);
    const NSBoxSensitive_Rep_Password = useRef<NSBoxSensitive>(null);

    function onApply(onFinished: () => void)
    {
        try
        {
            let pass_cur: string = NSBoxSensitive_Cur_Password.current?.getValue() ?? "";
            let pass_new: string = NSBoxSensitive_NewPassword.current?.getValue() ?? "";
            let pass_rep: string = NSBoxSensitive_Rep_Password.current?.getValue() ?? "";

            if (pass_new === pass_rep)
            {
                props.account.server.password.Reset({ pass_cur, pass_new, pass_rep }).then(() =>
                {
                    props.notifier.onSuccess("Your password have been changed successfully.");
                    props.notifier.onSuccess("Redirecting ...", 2000);
                    setTimeout(() =>
                    {
                        props.url.redirect(AccountRoutes.Home, {});
                        onFinished();
                    }, 2000);
                }).catch(onFinished);
            }
            else
            {
                props.notifier.onError("The passwords do not match. Please use the same password for both fields.");
                onFinished();
            }
        } catch (error)
        {
            props.notifier.onError(error as Error);
            onFinished();
        }
    }

    return (
        <AccountLayout {...props}
            title={{
                title: 'Change Password',
                description: 'Update your password for enhanced protection and security.'
            }}
        >
            <NSSection>
                <NSPanel>
                    {/* TODO: Needs a better solution */}
                    <input
                        type="text"
                        name="username"
                        autoComplete="username"
                        style={{ display: "none" }}
                    />
                    <NSBoxSensitive
                        ref={NSBoxSensitive_Cur_Password}
                        title="Current Password"
                        required={true}
                        placeholder="Please enter your current password"
                    />
                    <NSBoxSensitive
                        ref={NSBoxSensitive_NewPassword}
                        title="New Password"
                        required={true}
                        placeholder="Please enter your new password"
                    />
                    <NSBoxSensitive
                        ref={NSBoxSensitive_Rep_Password}
                        title="Confirm New Password"
                        required={true}
                        placeholder="Please enter your new password again"
                    />
                </NSPanel>
                <NSSpace size={NSSpaceSizeType.SMALL} />
                <NSButtonBlue
                    title="Apply"
                    onClick={{
                        action: (onFinished) =>
                        {
                            onApply(onFinished);
                        }
                    }}
                />
            </NSSection>
        </AccountLayout>
    );
}

export default PasswordChangePage;